import React from "react";
import { Container } from "react-bootstrap";
const DeleteAccount = () => {
  return (
    <div className="static_contnet">

    <Container>
      <h1>Important Information Before Deleting Your Account</h1>
      <h4>Deleting your account will:</h4>
      <ul>
        <li>
          Delete your account from Rimlig Taxi and all your devices where you
          are logged in.
        </li>
        <li>Erase your transaction history.</li>
        <li>Delete all your booking details.</li>
        <li>
          After deletion, you can come back anytime. However, please be aware
          that all data will be permanently erased and cannot be recovered.
        </li>
      </ul>
      <h2>Steps to Delete Your Account</h2>
      <ul>
        <li>Step 1: Go to side menu</li>
        <li>
        Step 2: Open settings.

        </li>
        <li>
        Step 3: There’s a delete button at the bottom of the screen.
        </li>
        <li>
        Step 4: Press “Delete My Account.” This will delete your account and navigate you to the login screen.
        </li>
      </ul>
    </Container>
    </div>
  );
};

export default DeleteAccount;
